import { Icon, Link, LinkProps } from '@chakra-ui/react';
import { FaPhoneAlt } from '@react-icons/all-files/fa/FaPhoneAlt';

import Button from '../../../../../../components/ui/buttons/Button';
import {
  BuyoutOverlaySource,
  trackBuyoutCallClicked,
} from '../../../../../../services/analytics/marketplaceEvents';
import getSearchPhoneNumbers from '../../../../../../utils/getSearchPhoneNumbers';

type BuyoutCallButtonProps = LinkProps & {
  source: BuyoutOverlaySource;
  dealId: string;
  leadId: string;
  isFullWidth?: boolean;
};

const BuyoutCallButton = ({
  source,
  dealId,
  leadId,
  isFullWidth = false,
  ...linkProps
}: BuyoutCallButtonProps) => {
  const phone = getSearchPhoneNumbers();

  return (
    <Link
      href={`tel:+1${phone.replace(/\D/g, '')}`}
      onClick={() => trackBuyoutCallClicked(dealId, leadId, source)}
      _hover={{ textDecoration: 'none' }}
      {...linkProps}
    >
      <Button
        as="span"
        leftIcon={<Icon as={FaPhoneAlt} boxSize="12px" />}
        size="sm"
        h="40px"
        w={isFullWidth ? '100%' : undefined}
      >
        Call {phone}
      </Button>
    </Link>
  );
};

export default BuyoutCallButton;
